import { categories } from "../endpoints/categories.endpoints";
import $axios from "../http/accessor";

const CategorisService = {
  getAllCategories: (search?: string) => {
    return $axios.get(categories.get_all, {
      params: {
        search,
      },
    });
  },

  createCategory: (data: FormData) => {
    return $axios.post(categories.create, data);
  },

  getSingleCategory: (id: number) => {
    return $axios.get(categories.get_by_id(id));
  },

  getByAttribute: (id: number) => {
    return $axios.get(categories.get_by_atribute(id));
  },

  deleteCategory: (id: number) => {
    return $axios.delete(categories.delete(id));
  },

  updateCategory: (id: number, data: FormData) => {
    return $axios.put(categories.edit(id), data);
  },
};

export default CategorisService;
